import { Pipe, PipeTransform } from '@angular/core';
import { SLMovementLineOwnership } from './movement';

@Pipe({ name: 'slmovementlineownership' })
export class SLMovementLineOwnershipPipe implements PipeTransform {
 
  transform(value: SLMovementLineOwnership, ...args: any[]) {
    if (value === 'PP') {
      return 'Pleine propriété';
    }
    else if(value === 'UF') {
      return 'Usufruit';
    }
    else if(value === 'NP') {
      return 'Nue Propriété';
    }
    else if(value === 'AT') {
      return 'Autres';
    }
    else {
      return value;
    }
  }
}
